<template>
    <div>
      <dailywork-report-list></dailywork-report-list>
    </div>
  </template>
  
  <script>
  export default {
  }
  </script>
  